import { processAndSendSearchEventLogData } from "OK/LoggerInfo";
/**
 * Модуль, логирующий показы (SearchAction.SHOW).
 * Отличается от LogSeen тем, что логируем то, что
 * отрисовалось клиенту, необязательное попавшее во вьюпорт.
 */
export class LogRender {
    activate(el: HTMLElement) {
        const attrs = el.getAttribute("data-render-log");
        if (attrs != null) {
            processAndSendSearchEventLogData(JSON.parse(attrs));
        }
    }

    deactivate() {}
}